import { useDispatch, useSelector } from "react-redux";
import {
  hasTimeViewerAccess,
  preparedFiltersWhoIsOut,
} from "../utils/timesUtils";
import {
  GetWhoIsOutUserList,
  IsLoading,
  loadWhoIsOutInfo,
  SelectProjectsWhoIsOut,
  setLoading,
} from "../redux/reducers/whoIsOutReport.reducer";
import { useCallback, useEffect } from "react";
import { TimesheetsService } from "../services/timesheets";
import {
  hasSuperTimeAdminAccess,
  isSupervisorOrProjectOwner,
} from "../../SharedModule/utils/accessUtils";

export const useWhoIsOutReport = (
  filters: any,
  isInfoWhoIsOutLoaded: boolean,
  userRolesList: any
) => {
  const dispatch = useDispatch();

  const isLoading = useSelector(IsLoading);
  const whoIsOutUserList = useSelector(GetWhoIsOutUserList);
  const projectsWhoIsOut = useSelector(SelectProjectsWhoIsOut);

  const isSuperTimeAdmin = hasSuperTimeAdminAccess(userRolesList);
  const isSupervisorOrPO = isSupervisorOrProjectOwner(userRolesList);
  const isTimeViewer = hasTimeViewerAccess(userRolesList);

  let filtersForRequest;
  if (isInfoWhoIsOutLoaded) {
    filtersForRequest = preparedFiltersWhoIsOut(
      filters,
      projectsWhoIsOut,
      isSuperTimeAdmin,
      isSupervisorOrPO,
      isTimeViewer
    );
  }

  const loadWhoIsOutResults = useCallback(async () => {
    dispatch(setLoading(true));
    if (isInfoWhoIsOutLoaded) {
      const results = await TimesheetsService.getWhoisOutInfo(
        filtersForRequest
      );
      dispatch(loadWhoIsOutInfo(results.data));
    }
  }, [dispatch, filters, isInfoWhoIsOutLoaded]);

  useEffect(() => {
    loadWhoIsOutResults();
  }, [loadWhoIsOutResults]);

  return {
    isLoading,
    whoIsOutUserList,
    filters,
  };
};
